<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Unallocated" name="unallocated">
        <unallocated ref="unallocated"/>
      </el-tab-pane>
      <el-tab-pane label="Allocated" name="allocated">Allocated</el-tab-pane>
      <el-tab-pane label="Entered" name="entered">Entered</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Unallocated from '@/components/sourceDocuments/vendorInvoices/Unallocated'

  export default {
    name: 'Vendor Invoices',
    components: {
      Unallocated
    },
    data() {
      return {
        activeName: 'unallocated',
      }
    },
    methods: {
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
      },
      openTab() {
        this.activeName = 'unallocated'
        this.$refs['unallocated'].openTab()
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>